import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutAlignLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLayoutAlignLeft"><Path d="M20.5 3.5H21V3L20.5 3V3.5ZM3.5 3.5L3.5 3H3L3 3.5L3.5 3.5ZM3.5 20.5H3V21H3.5V20.5ZM20.5 20.5V21H21V20.5H20.5ZM6.99999 16.5V17H7.99999V16.5H6.99999ZM7.99999 7.5V7H6.99999V7.5H7.99999ZM20.5 3L3.5 3L3.5 4L20.5 4V3ZM3 3.5L3 20.5H4L4 3.5L3 3.5ZM3.5 21H20.5V20H3.5V21ZM21 20.5V3.5H20V20.5H21ZM7.99999 16.5V7.5H6.99999V16.5H7.99999Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutAlignLeft;
